import { cacheUtil } from '@beecode/msh-node-util/lib/cache-util'
import { apiRepoFactory } from '@zeus/common/lib/business/repo/api-repo'
import { axiosAuthorisationInterceptor } from '@zeus/react-common/lib/lib/axios/axios-authorisation-interceptor'

export const apiRepo = cacheUtil.singleton(() => apiRepoFactory({ authorisedInterceptors: [axiosAuthorisationInterceptor] }))
